import useModalStore from '../../../ui/uiElements/advanced/modal/dataLayer/hooks/UseModalStore';
import { bugReporterModalKey } from '../BugReporter';
export default function useBugReporter() {
    var modalStore = useModalStore();
    return {
        openBugReporter: function (customProperties) {
            modalStore.openModal(bugReporterModalKey, customProperties);
        }
    };
}
//# sourceMappingURL=UseBugReporter.js.map